import { PublicClientApplication } from '@azure/msal-browser';

export const msalConfig = {
    auth: {
        clientId: "c3448b11-4fb0-4885-b187-dc0c5bab4643",
        authority: "https://login.microsoftonline.com/d53a807a-b642-4943-b7fe-a364af4f7df2",
        redirectUri: typeof window !== 'undefined' ? window.location.origin : "https://administrativo.infra-designcr.com",
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    }
};

// Scope de Microsoft Graph (login / perfil). Se mantiene.
export const loginRequest = {
    scopes: ["User.Read"]
};

// Scope propio del API (v49a). El frontend pide ESTE token para llamar al
// backend; el access token resultante trae el claim `groups` con el que el
// API resuelve el rol. El Application ID URI se expone en el App Registration.
export const apiRequest = {
    scopes: ["api://c3448b11-4fb0-4885-b187-dc0c5bab4643/access_as_user"]
};

// ID del grupo autorizado (gate de interfaz; el backend valida por su cuenta).
export const GRUPO_AUTORIZADO = "0be635e8-6386-4a1b-b4ca-2bd07103c993";

// Instancia única de MSAL, compartida entre React (MsalProvider en index.js) y
// el resolver de token fuera de componentes (config/http.js). NO duplicar:
// crear una segunda instancia rompe el cache de tokens y la sesión.
export const msalInstance = new PublicClientApplication(msalConfig);
